<div class="p-inputgroup align-items-center flex">
  <p-inputSwitch [ngModel]="model" (ngModelChange)="modelChange.emit($event)" [disabled]="disabled"></p-inputSwitch>
  <label *ngIf="hasLabel" [style.width]="labelWidth" class="ml-2">{{ label }}</label>
</div>
